import React, { useEffect, useState, ReactNode } from 'react';
import { Button, LinearProgress, CircularProgress } from '@material-ui/core';
import { Boxes } from './Boxes';
import { useRecoilState } from 'recoil';
import { btnColor } from '../../GlobalState';
import { getExtInfoBoxes, updateExtInfoBoxes } from '../../apicalls/extInfoBox';
import { TInfoBox, TInfoBoxForms } from '../../types/ExtInfoBox';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';

type Tprops = {
  defaultValues: TInfoBox[];
  targetId: number;
  ext_info_screen_type: number;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  getData: any;
};

export const ExtInfoBoxes: React.FC<Tprops> = (props: Tprops) => {
  const {
    defaultValues,
    targetId,
    ext_info_screen_type,
    setOpen,
    setOpenSuccess,
    setErrorMessage,
    getData
  } = props;

  const [buttonColor] = useRecoilState(btnColor);

  const methods: UseFormReturn<TInfoBoxForms, any> = useForm<TInfoBoxForms>({
    defaultValues: { infoData: defaultValues }
  });
  const {
    setValue,
    getValues,
    handleSubmit,
    register,
    formState: { errors }
  } = methods;

  const onSubmit = (input: TInfoBoxForms) => {
    const data = input.infoData;

    updateExtInfoBoxes(data, targetId, ext_info_screen_type).then(data => {
      if (data.data === 'Not logged in!') {
        setOpen(true);
        setErrorMessage(data.data);
      } else {
        if (typeof data.data === 'string') {
          setOpen(true);
          setErrorMessage(data.data);
        } else {
          setOpenSuccess(true);
          setErrorMessage('更新成功');
          getData();
        }
      }
    });
  };

  useEffect(() => {
    console.log(defaultValues);
  }, [defaultValues]);

  return (
    <FormProvider {...methods}>
      {defaultValues &&
        defaultValues.length > 0 &&
        defaultValues.map((boxData: TInfoBox, index: number) => (
          <Boxes
            boxData={boxData}
            boxNo={index}
            register={register}
            setValue={setValue}
            errors={errors}
            key={index}
            ext_info_screen_type={ext_info_screen_type}
          />
        ))}
      <div
        className='save-btn-container'
        style={{
          backgroundColor: '#FFFFFF',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-around'
        }}
      >
        <div />
        <div>
          <Button
            onClick={handleSubmit(onSubmit)}
            style={{
              paddingLeft: 50,
              paddingRight: 50,
              margin: 20,
              backgroundColor: buttonColor
            }}
            variant='contained'
            color='primary'
          >
            保存
          </Button>
        </div>
        <div />
      </div>
    </FormProvider>
  );
};
